export default __webpack_public_path__ + "static/stacked-area-7de7bbe3bb4b245c0a27c26e45b564a9.png";